import {useEffect, useState, MouseEvent} from 'react'
import GridComponent from '../../../component/grid/GridComponent.component';
import Table from '../../../component/table/Table.component';
import { useSnackbar } from '../../../context/Snackbar';
import { Pagination } from '../../../component/table/interfaces/Pagination';
import { INITIAL_PAGINATION } from '../../../component/table/component/pagination/utils/Pagination';
import { Action, ACTION_EDIT_SUBMIT, ACTION_DELETE } from '../../../component/table/interfaces/TableInterface';
import useModal from '../../../hooks/useModal';
import Modal from '../../../component/modal/Modal.component';
import ModalDelete from '../../../component/modal/ModalDelete.component';
import { Format } from './interfaces/Format';
import ButtonFormFull from '../../../component/buttton/ButtonFormFull.component';
import { INITIAL_VALUES } from './utils/INITIAL_VALUES';
import FormFormat from './form/Form.component';
import { getFormat, deleteFormat, putFormat, postFormat } from './Format.service';
import { HEAD_CELL } from './utils/HEAD_CELL';
import { compare } from '../../../utils/order/compare';

const FormatComponent = () => {

    const { setSnackbar } = useSnackbar();
    const [request, setRequest] = useState<boolean>(true);
    const [format, setFormat] = useState<Format[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);
    const [open, addModal] = useModal();

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPagination({ ...pagination, page: newPage + 1 });
  };

  const handleRequestSort = (_event: MouseEvent<unknown>, property: string) => {
    const isAsc = pagination.sort === property && pagination.order === 1;
    setPagination({ ...pagination, sort: property, order: isAsc ? -1 : 1 });
  };

  const handleClickAction = (action: Action, formatItem: Format) => {
    if (action === ACTION_EDIT_SUBMIT) {
      return registerFormat(formatItem);
  }
  if (action === ACTION_DELETE) {
      return addModal(formatItem.id);
  }
  };

  const getData = async () => {
    setRequest(true)
    await getFormat({page: pagination.page}).then(response => {
      if(response.data.data){
        setFormat(response.data.data)
        setTotal(response.data.total)
      }
      setRequest(false)
    }).catch((err) =>{
      setRequest(false)
      setSnackbar({ msg: `Erro ao coletar novos dados`, type: 'error' });
    })
  }

  useEffect(() => {
    getData()
  }, [pagination])


  const registerFormat = async (formatItem: Format) => {
    try {
        setRequest(true);
        await (formatItem.id ? putFormat(formatItem) : postFormat(formatItem));
        setSnackbar({ msg: `Formato foi ${formatItem.id ? 'atualizado' : 'cadastrado'} com sucesso!`, type: 'success' });
        addModal(false);
        getData()
    } catch (error) {
        console.log('Erro ao submeter formato!', error);
        setSnackbar({ msg: `Erro ao ${formatItem.id ? 'atualizar' : 'cadastrar'} formato!`, type: 'error' });
        setRequest(false);
    }
  }

  const handleClickDelete = async () => {
      setRequest(true);
      await deleteFormat(Number(open)).then(res => {
          setSnackbar({ msg: "Formato excluído com sucesso!", type: 'success' });
          setRequest(false);
      }).catch(error => {
          console.log('Erro ao excluir formato!', error);
          setSnackbar({ msg: "Erro ao excluir formato!", type: 'error' });
          setRequest(false);
      }).finally(function () {
          addModal(undefined);
      });
  };

  return (
    <>
      <GridComponent justify="flex-end" alignItems="flex-end" >
        <Modal title="Criar formato" open={open === true} handleClick={() => addModal(!open)}  >
          <FormFormat initialValues={INITIAL_VALUES} handleSubmitForm={registerFormat}  >
              <ButtonFormFull disabled={request} onClick={() => addModal(false)} />
          </FormFormat>
        </Modal>
      </GridComponent>
      <ModalDelete open={!!open && open !== true} handleClick={() => addModal(undefined)} onClickSubmit={handleClickDelete} title="Confirma a exclusão desse formato?" />
      <br />
      <br />
      <Table
          request={request}
          data={format.sort((a: any, b: any) => compare(a, b, pagination.sort || 'id', pagination.order))}
          size={total}
          headCells={HEAD_CELL}
          page={pagination.page}
          onChangePage={handleChangePage}
          editable
          noActionView
          handleClickAction={handleClickAction}
          order={pagination.order === 1 ? 'asc' : 'desc'}
          orderBy={pagination.sort}
          onRequestSort={handleRequestSort}
          md={6}
          xl={4}
      />
    </>
  )
}

export default FormatComponent;
